import { EMPTY_ARRAY } from 'commons-ui';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import {} from '../../helper';
import { ActionListParams, DowntimeRefundRequestRecord } from '../types';
import { DowntimeRefundAction, DowntimeRefundActionLabel, DowntimeRefundRequestStatus } from '../models';

export const makeActionList = (params: ActionListParams) => {
	const { hasPermission, appName } = params;
	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: [
			{
				name: DowntimeRefundActionLabel[DowntimeRefundAction.APPROVE],
				id: DowntimeRefundAction.APPROVE,
				isEnabled: (rowData: DowntimeRefundRequestRecord) => {
					const { status } = rowData;
					if (status !== DowntimeRefundRequestStatus.WAITING_FOR_APPROVAL) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.downtimeRefund,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.downtimeRefund].approveRefundRequest,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: DowntimeRefundActionLabel[DowntimeRefundAction.REJECT],
				id: DowntimeRefundAction.REJECT,
				isEnabled: (rowData: DowntimeRefundRequestRecord) => {
					const { status } = rowData;
					if (status !== DowntimeRefundRequestStatus.WAITING_FOR_APPROVAL) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.downtimeRefund,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.downtimeRefund].rejectRefundRequest,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: DowntimeRefundActionLabel[DowntimeRefundAction.DOWNLOAD],
				id: DowntimeRefundAction.DOWNLOAD,
				isEnabled: (rowData: DowntimeRefundRequestRecord) => {
					const { status } = rowData;
					if (status === DowntimeRefundRequestStatus.IN_PROGRESS || status === DowntimeRefundRequestStatus.FAILED) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.downtimeRefund,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.downtimeRefund].downloadRefundRequest,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: DowntimeRefundActionLabel[DowntimeRefundAction.GET_REFUND_STATUS],
				id: DowntimeRefundAction.GET_REFUND_STATUS,
				isEnabled: (rowData: DowntimeRefundRequestRecord) => {
					const { status } = rowData;
					if (status !== DowntimeRefundRequestStatus.APPROVED) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.downtimeRefund,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.downtimeRefund].getRefundRequestStatus,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: DowntimeRefundActionLabel[DowntimeRefundAction.ADD],
			id: DowntimeRefundAction.ADD,
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.downtimeRefund,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.downtimeRefund].createRefundRequest,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
